/*
 * Text Us bubble (sections/text-us-bubble.liquid).
 * Opens/closes the panel and POSTs name + mobile + message to the dashboard's
 * quote-request-public Edge Function with form: 'text-us'.
 * Ported from Arctic-Spas-Prestige-Theme/assets/prestige.js.
 */
(function () {
  document.querySelectorAll('[data-text-us]').forEach(function (root) {
    var toggle = root.querySelector('[data-text-us-toggle]');
    var panel = root.querySelector('.text-us__panel');
    var form = root.querySelector('[data-text-us-form]');
    var okEl = root.querySelector('[data-text-us-ok]');
    var errEl = root.querySelector('[data-text-us-error]');
    var submit = root.querySelector('[data-text-us-submit]');
    if (!toggle || !panel) return;

    var open = false;
    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        panel.hidden = false;
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
        var first = panel.querySelector('input:not([type="hidden"]):not([tabindex="-1"]), textarea');
        if (first) setTimeout(function () { first.focus(); }, 150);
      } else {
        panel.classList.remove('is-open');
        setTimeout(function () { if (!open) panel.hidden = true; }, 320);
      }
    }

    toggle.addEventListener('click', function () { setOpen(!open); });
    root.querySelectorAll('[data-text-us-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (open && !root.contains(e.target)) setOpen(false);
    });

    if (!form) return;
    var endpoint = form.dataset.endpoint;
    var messages = {
      invalid_phone: 'Please enter a mobile number we can text (10 digits).',
      missing_message: 'Add a short message so we know how to help.',
      missing_intent: 'Tell us what this is about so the right person replies.',
      invalid_intent: 'Tell us what this is about so the right person replies.',
      too_many_requests: 'Too many messages from this connection. Please try again in an hour, or call the showroom.',
      network: 'We could not send that. Please try again, or call the showroom.'
    };
    function param(k) {
      try {
        return new URL(window.location.href).searchParams.get(k) || undefined;
      } catch (e) {
        return undefined;
      }
    }

    // "What's this about?" — pre-select from the page the visitor is on; on a
    // product, collection, search or policy page the answer is almost always
    // parts / an order (2026-10-25 audit: 9 of 14 such notes came from those
    // pages, none about a sale). Anywhere else one tap is required.
    function presetIntent() {
      var path = window.location.pathname;
      var guess = '';
      if (/^\/(products|collections|search|policies|cart|pages\/shop)(\/|$)/.test(path)) guess = 'product';
      else if (/service|repair/.test(path)) guess = 'service';
      if (!guess) return;
      var radio = form.querySelector('input[name="intent"][value="' + guess + '"]');
      if (radio && !form.querySelector('input[name="intent"]:checked')) radio.checked = true;
    }
    presetIntent();
    function chosenIntent() {
      var checked = form.querySelector('input[name="intent"]:checked');
      return checked ? checked.value : '';
    }
    // The "what's this about" error lives inside the chip group: the status
    // line under the Send button is below the fold on most phones, so a
    // visitor who tapped Send with no chip saw nothing (design audit
    // 2026-10-26, #42). Shown there, scrolled into view, cleared on a choice.
    var intentGroup = form.querySelector('[data-text-us-intent]');
    var intentErr = form.querySelector('[data-text-us-intent-error]');
    function showIntentError() {
      if (intentErr) { intentErr.textContent = messages.missing_intent; intentErr.hidden = false; }
      if (intentGroup) {
        intentGroup.classList.add('is-invalid');
        try { intentGroup.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { /* old browsers */ }
      }
      var firstChip = form.querySelector('input[name="intent"]');
      if (firstChip) firstChip.focus({ preventScroll: true });
    }
    function clearIntentError() {
      if (intentErr) intentErr.hidden = true;
      if (intentGroup) intentGroup.classList.remove('is-invalid');
    }
    form.querySelectorAll('input[name="intent"]').forEach(function (r) {
      r.addEventListener('change', clearIntentError);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      if (!chosenIntent()) {
        showIntentError();
        return;
      }
      clearIntentError();
      // Shopify renders forms with novalidate, so `required` is inert until we
      // ask for it field by field.
      var required = form.querySelectorAll('[required]:not([type="radio"])');
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checkValidity()) {
          required[i].reportValidity();
          return;
        }
      }
      var phone = form.elements.phone.value.trim();
      if (phone.replace(/\D/g, '').length < 10) {
        errEl.textContent = messages.invalid_phone;
        errEl.hidden = false;
        form.elements.phone.focus();
        return;
      }

      var payload = {
        form: 'text-us',
        intent: chosenIntent(),
        name: form.elements.name.value.trim(),
        phone: phone,
        message: form.elements.message.value.trim(),
        website: form.elements.website ? form.elements.website.value : '',
        landing_page: window.location.href.slice(0, 500),
        referrer: (document.referrer || '').slice(0, 500),
        utm_source: param('utm_source'),
        utm_medium: param('utm_medium'),
        utm_campaign: param('utm_campaign')
      };
      Object.keys(payload).forEach(function (k) {
        if (payload[k] === undefined) delete payload[k];
      });

      // Optimistic: the thank-you shows at once and the request runs behind it
      // with no spinner. The fields are cleared only once the send succeeds, so
      // a failure puts the form back with the message intact and the error shown.
      showThanks();
      fetch(endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          if (r.ok && r.data && r.data.ok) {
            form.reset();
            presetIntent();
            return;
          }
          showForm(messages[r.data && r.data.error] || messages.network);
        })
        .catch(function () {
          showForm(messages.network);
        });
    });

    // The thank-you is a moment, not a state: after a few seconds (or when the
    // panel closes) the form comes back ready for another note.
    var resetTimer;
    function showThanks() {
      form.hidden = true;
      okEl.hidden = false;
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () { showForm(); }, 4000);
    }
    function showForm(error) {
      clearTimeout(resetTimer);
      okEl.hidden = true;
      form.hidden = false;
      clearIntentError();
      errEl.textContent = error || '';
      errEl.hidden = !error;
      if (error && !open) setOpen(true);
    }
    root.querySelectorAll('[data-text-us-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (!okEl.hidden) showForm(); });
    });
    // Back/forward navigation restores the page from the bfcache with the
    // thank-you still up — start clean.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && !okEl.hidden) showForm();
    });
  });
})();
